export enum TenantSelectionMessages {
  title = "tenantSelection.title",
  currentTenant = "tenantSelection.currentTenant",
  confirmTenantSelectionModalTitle = "tenantSelection.confirmTenantSelectionModalTitle",
  confirmTenantSelectionModalContent = "tenantSelection.confirmTenantSelectionModalContent"
}

export interface TranslationTenantSelectionMessages {
  [TenantSelectionMessages.title]: string;
  [TenantSelectionMessages.currentTenant]: string;
  [TenantSelectionMessages.confirmTenantSelectionModalTitle]: string;
  [TenantSelectionMessages.confirmTenantSelectionModalContent]: string;
}